import PrincipalSearchCustomers from './PrincipalSearchCustomers'

export default PrincipalSearchCustomers
